import React from "react";
import styles from "../styles/Retail.module.css"; // Make sure this path is correct
import Header from "../components/Header"; // Make sure this path is correct
import Footer from "../components/Footer"; // Make sure this path is correct

// Use direct imports if the images are in the same directory or a public folder
import pic from "../assets/ho.JPG";
import payment from "../assets/hospitality.JPG";
import { Link } from "react-router-dom";
import view from "../assets/hos.png";
import imag from "../assets/gateway.png";
import solution from "../assets/hospi.png";
import newer from "../assets/mobile.JPG";

const Hospitality = () => {
  return (
    <div>
      <Header />
      <div className={styles.empoweringSection}>
        <div className={styles.hero}>
          <div className={styles.heroContent}>
            <p style={{ fontSize: "30px", fontWeight:"bold" }} className={styles.msmesLabel}>
              HOSPITALITY
            </p>
            <h1 className={styles.heroTitle}>
              Innovative Payment Solutions
               Transforming <br />The Hospitality Sector
            </h1>
            <Link to="/ContactUs">
              <button className={styles.contactButton}>Contact Us →</button>
            </Link>
          </div>
          <div className={styles.heroImage}>
            <img
              style={{
                borderRadius: "40px",
                // marginRight: "250px",
                width: "500px",
                height: "300px",
              }}
              src={payment}
              alt="Payment terminal in a shop"
            />
          </div>
        </div>
      </div>
      <div className={styles.container}>
        <div className={styles.helpingSection}>
          <div className={styles.helpingText}>
            <h2
              style={{ marginBottom: "20px" }}
              className={styles.helpingTitle}
            >
             HOSPITALITY & LEISURE
            </h2>
            <p className={styles.helpingDescription}>
          Innovative Payment Solutions Tailored for Hospitality & Guest Services
Deliver exceptional experiences across hotels, restaurants, travel services, and entertainment venues with our flexible, guest-centric payment solutions.
            </p>
          </div>
        </div>
        </div>
       <div className={styles.contents}>
  {/* Section 1 - Image Left, Text Right */}
  <section>
    <div
      className={styles.newContent}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "140px",
        maxWidth: "1200px",
        margin: "0 auto",
        padding: "40px 20px"
      }}
    >
      <div className={styles.solutionImage}>
        <img
          src={pic}
          alt="feature payment"
          style={{
            width: "450px",
            height: "250px",
            borderRadius: "15px",
            objectFit: "cover"
          }}
        />
      </div>
      <div className={styles.viewText} style={{ maxWidth: "600px" }}>
        <h2 style={{ 
          fontSize: "20px",
          color: "#333",
          marginBottom: "20px"
        }}>
         Enhance Guest Satisfaction
        </h2>
        <p style={{ 
          fontSize: "16px",
          color: "black",
          lineHeight: "1.6"
        }}>
          <span className={styles.icon}>✦</span> Offer fast, secure, and reliable payments that make every check-in, order, or booking seamless boosting satisfaction across touchpoints.
        </p>
      </div>
    </div>
  </section>

  {/* Section 2 - Text Left, Image Right */}
  <section className={styles.thirdLayer}>
    <div className={styles.newContentReverse}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexDirection: "row-reverse",
      gap: "140px",
        maxWidth: "1200px",
        margin: "0 auto",
        padding: "40px 20px"
      }}
    >
      <div className={styles.solutionImageReverse}>
        <img
          src={imag}
          alt="advanced payment"
          style={{
            width: "450px",
            height: "250px",
            borderRadius: "15px",
            border: "6px solid rgba(143, 188, 143, 0.3)",
            objectFit: "cover"
          }}
        />
      </div>
      <div className={styles.viewTextReverse} style={{ maxWidth: "600px" }}>
        <h2 style={{ 
          fontSize: "20px",
          color: "#333",
          marginBottom: "20px"
        }}>
         Accept Any Payment Method
        </h2>
        <p style={{ 
          fontSize: "16px",
          color: "black",
          lineHeight: "1.6",
          marginBottom: "15px"
        }}>
          <span className={styles.icon}>✦</span> Support a wide range of payments including cards, mobile wallets, and QR codes to give both local and international guests the freedom to pay their way.
        </p>
        {/* <p style={{ 
          fontSize: "1.2rem",
          color: "black",
          lineHeight: "1.6"
        }}>
          <span className={styles.icon}>✦</span> We also offer a variety of commerce services to enhance service excellence with dedicated, streamlined applications tailored for the hospitality industry.
        </p> */}
      </div>
    </div>
  </section>

  {/* Section 3 - Image Left, Text Right */}
  <section className={styles.thirdLayer}>
    <div  className={styles.newContent}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      gap: "140px",
        maxWidth: "1200px",
        margin: "0 auto",
        padding: "40px 20px"
      }}
    >
      <div className={styles.solutionImage}>
        <img
          src={view}
          alt="feature payment"
          style={{
            width: "450px",
            height: "250px",
            borderRadius: "15px",
            objectFit: "cover"
          }}
        />
      </div>
      <div className={styles.viewText} style={{ maxWidth: "600px" }}>
        <h2 style={{ 
          fontSize: "20px",
          color: "#333",
          marginBottom: "20px"
        }}>
         Boost Operational Efficiency
        </h2>
        <p style={{ 
          fontSize: "16px",
          color: "black",
          lineHeight: "1.6"
        }}>
          <span className={styles.icon}>✦</span>Automate reconciliation, monitor staff activity, and reduce manual errors with centralized dashboards and real-time reporting tools.
          {/* <br /><br />
          <span className={styles.icon}>✦</span> Our terminals can support a variety of additional services, such as bill splitting, loyal programs, self-checkout, subscriptions to new services, RFID hotel room key management, and ticketing for entertainment. */}
        </p>
      </div>
    </div>
  </section>

  {/* Section 4 - Text Left, Image Right */}
  <section className={styles.thirdLayer}>
    <div className={styles.newContentReverse}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexDirection: "row-reverse",
      gap: "140px",
        maxWidth: "1200px",
        margin: "0 auto",
        padding: "40px 20px",
        marginBottom: "80px"
      }}
    >
      <div className={styles.solutionImageReverse}>
        <img
          src={solution}
          alt="advanced payment"
          style={{
            width: "450px",
            height: "250px",
            borderRadius: "15px",
            border: "6px solid rgba(143, 188, 143, 0.3)",
            objectFit: "cover"
          }}
        />
      </div>
      <div className={styles.viewTextReverse} style={{ maxWidth: "600px" }}>
        <h2 style={{ 
          fontSize: "20px",
          color: "#333",
          marginBottom: "20px",
          lineHeight: "1.3"
        }}>
        Create New Revenue Streams
        </h2>
        <p style={{ 
          fontSize: "16px",
          color: "black",
          lineHeight: "1.6",
          marginBottom: "15px"
        }}>
          <span className={styles.icon}>✦</span> Enable features like split bills, subscriptions, loyalty programs, and remote ordering to generate more value from every guest interaction.
        </p>
        {/* <p style={{ 
          fontSize: "1.2rem",
          color: "black",
          lineHeight: "1.6"
        }}>
          <span className={styles.icon}>✦</span> Terminal as a Service (TaaS) allows you to fully outsource the management of your fleet, freeing up your staff to focus on improving your guest's experience.
        </p> */}
      </div>
    </div>
  </section>
</div>


      <section className={styles.bottom}>
        <div
          className={styles.bottom}
          style={{
            backgroundColor: "var(--primary-green)",
            color: "#fff",
            padding: "20px 30px",
            borderRadius: "35px",
            margin: "40px 70px 40px 50px",
          }}
        >
          <div
            style={{
              maxWidth: "1200px",
              margin: "0 auto",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
            }}
          >
            {/* Text Content */}
            <div style={{ flex: "1", maxWidth: "550px", marginBottom: "30px" }}>
              <h2
                style={{
                  fontSize: "2em",
                  marginBottom: "15px",
                  color: "white",
                }}
              >
                Become a partner
              </h2>
              <p style={{ fontSize: "0.9em" }}>
                <span style={{ color: "white", fontSize: "0.6em" }}>✦</span>{" "}
                Become a partner right for you, who understands your unique
                busines and <br />
                industry needs.
              </p>
              <Link to="/become-a-partner">
                <button
                  className={styles.but}
                  style={{
                    backgroundColor: "#fff",
                    color: "green",
                    border: "none",
                    padding: "15px 30px",
                    borderRadius: "5px",
                    fontSize: "16px",
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                >
                  Become a partner →
                </button>
              </Link>
            </div>

            {/* Image Side */}
            <div
              style={{ flex: "1", display: "flex", justifyContent: "flex-end" }}
            >
              <img
                src={newer} // your actual image path
                alt="Payment Terminal"
                style={{
                  width: "100%",
                  maxWidth: "450px",
                  height: "auto",
                  objectFit: "cover",
                  borderRadius: "25px",
                  border: "5px solid green",
                }}
              />
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Hospitality;
